/* eslint-disable */
import { useEffect, useState } from "react";
import { Table, Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "hooks/useStore";
import request from "utils/request";
import config from "./table.config";
import AlarmInfoModal from "./components/AlarmInfoModal";
import AlarmDeviationAnalysisModal from "./components/AlarmDeviationAnalysisModal";
import "./styles.css";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import CloseAllAlarmsModal from "./components/CloseAllAlarmsModal";

const { confirm } = Modal;

const ActiveAlarms = observer(
  ({
    data,
    mutate,
    alarmCountMutate,
    dataDeviationAlarms,
    fetchDeviationAlarms,
  }) => {
    const {
      wellStore
    } = useStore();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [closeAlarmsModalVisible, setCloseAlarmsModalVisible] = useState(false);
    const [tableData, setTableData] = useState(null);
    const [alarmType, setAlarmType] = useState(null);
    const handleCloseAlarm = async (id, comment) => {
      result.comment = comment;
      result.alarmId = id;
      await request.post(`/alarm/${id}/close`, result);
      wellStore.resetIsAlarmsReload();
      await mutate();
      await alarmCountMutate();
    };
    const storageTranslationsWorkReasons = JSON.parse(
      sessionStorage.getItem("translationsWorkReasons")
    );

    const result = {
      userId: 1,
      comment: null,
    };

    const sendNewActionsRequest = async (values) => {
      await request.post("/alarm/works/add", values);
      wellStore.resetIsAlarmsReload();
      await mutate();
      await alarmCountMutate();
    };

    const sendNewObservationRequest = async (values) => {
      await request.post("/alarm/observations/add", values);
      wellStore.resetIsAlarmsReload();
      await mutate();
      await alarmCountMutate();
    };

    const handleCloseWork = async (alarmId, workId, comment) => {
      result.comment = comment;
      result.alarmId = alarmId;
      await request.post(`/alarm/works/close/${workId}`, result);
      wellStore.resetIsAlarmsReload();
      await mutate();
      await alarmCountMutate();
    };

    const handleDoneWork = async (alarmId, workId, comment) => {
      result.comment = comment;
      result.alarmId = alarmId;
      await request.post(`/alarm/works/done/${workId}`, result);
      wellStore.resetIsAlarmsReload();
      await mutate();
    };

    const handleCloseObservation = async (alarmId, observationId, comment) => {
      result.comment = comment;
      result.alarmId = alarmId;
      await request.post(`/alarm/observations/close/${observationId}`, result);
      wellStore.resetIsAlarmsReload();
      await mutate();
    };

    const handleDoneObservation = async (alarmId, observationId, comment) => {
      result.comment = comment;
      result.alarmId = alarmId;
      await request.post(`/alarm/observations/done/${observationId}`, result);
      wellStore.resetIsAlarmsReload();
      await mutate();
    };

    const handleCloseDeviationAnalysisAlarm = async (reasons) => {
      await request.post(
        `/alarm/deviationanalysis/update/${wellStore.id}`,
        reasons
      );
      wellStore.resetIsAlarmsReload();
      await fetchDeviationAlarms();
    };

    const getRecord = (record) => {
      setSelectedRecord(record);
    };

    const closeAllAlarms = async () => {
      await request.delete(`/alarm/closeall`)
      wellStore.resetIsAlarmsReload();
      await fetchDeviationAlarms();
      setCloseAlarmsModalVisible(false)
    }

    const closeAllAlarmsByWellId = async () => {
      await request.delete(`/alarm/close/${wellStore.id}`)
      wellStore.resetIsAlarmsReload();
      await fetchDeviationAlarms();
      setCloseAlarmsModalVisible(false)
    }

    const executeTrendAnalysis = async () => {
      const trendRedisData = {
        action: "analyze_all",
        wellId: null
      }
      await request.post(`/trend-analysis-settings/command`, trendRedisData)
      setCloseAlarmsModalVisible(false)
    }

    const executeTrendAnalysisByWell = async () => {
      const trendRedisData = {
        action: "analyze",
        wellId: `${wellStore.id}`
      }
      await request.post(`/trend-analysis-settings/command`, trendRedisData)
      setCloseAlarmsModalVisible(false)
    }

    const calculateAlarmsForClosing = () => {
      let count = 0;
      dataDeviationAlarms && dataDeviationAlarms.forEach(element => {
        if (element?.type != "INSTANTANEOUS") count++
      });

      return count
    }

    const showDeleteConfirm = () => {
      confirm({
        title: 'Закрыть все предупреждения по скважине?',
        icon: <ExclamationCircleOutlined />,
        content: `Будет закрыто ${calculateAlarmsForClosing()} предупреждений`,
        okText: 'ДА',
        okType: 'danger',
        cancelText: 'НЕТ',
        onOk() {
          console.log('OK');
          closeAllAlarms();
        },
        onCancel() {
          console.log('Отмена');
        },
      });
    };

    const changeCloseAlarmsModalVisible = () => {
      console.log(closeAlarmsModalVisible)
      setCloseAlarmsModalVisible(!closeAlarmsModalVisible)
    }

    const closeModalAllAlarms = () => {
      setCloseAlarmsModalVisible(false)
    }

    useEffect(() => {
      if (!dataDeviationAlarms) return;
      dataDeviationAlarms.forEach((element) => {
        if (element.type == "CUSTOM") {
          if (
            storageTranslationsWorkReasons["ru"][
              element?.selectedActions?.workReasonId - 1
            ]?.translation
          )
            element.name =
              storageTranslationsWorkReasons["ru"][
                element.selectedActions.workReasonId - 1
              ].translation;
        }
      });
      setTableData(dataDeviationAlarms);
    }, [dataDeviationAlarms]);

    return (
      <div className="alarm-content">
        <Table
          columns={config(
            wellStore?.dataDeviationAlarms?.name,
            handleCloseAlarm,
            wellStore.id,
            handleCloseWork,
            handleDoneWork,
            handleCloseObservation,
            handleDoneObservation,
            sendNewActionsRequest,
            sendNewObservationRequest,
            true,
            getRecord,
            setIsModalVisible,
            isModalVisible,
            setAlarmType,
            changeCloseAlarmsModalVisible,
            calculateAlarmsForClosing()
          )}
          dataSource={tableData?.map((item) => ({ ...item, key: item.id }))}
          pagination={false}
          className="alerts-table"
          rowClassName="alerts-row"
          sticky
        />
        <AlarmInfoModal
          visible={isModalVisible && (alarmType !== "INSTANTANEOUS") && (alarmType != null)}
          closeModal={() => setIsModalVisible(false)}
          data={selectedRecord}
          wellName={wellStore?.data?.name}
          well_id={wellStore.id}
          closeWork={handleCloseWork}
          doneWork={handleDoneWork}
          closeObservation={handleCloseObservation}
          doneObservation={handleDoneObservation}
          handleCloseObservation={handleCloseObservation}
          handleDoneObservation={handleDoneObservation}
          sendNewActionsRequest={sendNewActionsRequest}
          handleCloseAlarm={handleCloseAlarm}
          sendNewObservationRequest={sendNewObservationRequest}
          handleCloseDeviationAnalysisAlarm={handleCloseDeviationAnalysisAlarm}
        />

        <AlarmDeviationAnalysisModal
          visible={isModalVisible && (alarmType === "INSTANTANEOUS")}
          closeModal={() => setIsModalVisible(false)}
          data={selectedRecord}
          handleCloseDeviationAnalysisAlarm={handleCloseDeviationAnalysisAlarm}
          isAlarmArchived={false}
        />

        <CloseAllAlarmsModal 
          visible={closeAlarmsModalVisible}
          closeModal={() => closeModalAllAlarms()}
          closeAllAlarms={closeAllAlarms}
          closeAllAlarmsByWellId={closeAllAlarmsByWellId}
          executeTrendAnalysis={executeTrendAnalysis}
          executeTrendAnalysisByWell={executeTrendAnalysisByWell}
          alarmsCount={calculateAlarmsForClosing()}
          wellName={wellStore?.data?.name}
        />

      </div>
    );
  }
);

export default ActiveAlarms;
